import React, { useState } from 'react';
import { Container, Nav, Tab, Toast } from 'react-bootstrap';
import TemplateList from '../components/templates/TemplateList';
import AddTemplate from '../components/templates/AddTemplate';
import TestTemplate from '../components/templates/TestTemplate';

const MessageTemplatesPage = () => {
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');

    const showNotification = (message, variant = 'success') => {
        setToastMessage(message);
        setToastVariant(variant);
        setShowToast(true);
    };

    return (
        <Container fluid className="message-templates-container py-4">
            {/* Toast Notification */}
            <div className="toast-container">
                <Toast 
                    show={showToast} 
                    onClose={() => setShowToast(false)}
                    delay={3000}
                    autohide
                    className={`bg-${toastVariant} text-white`}
                >
                    <Toast.Body>
                        <i className={`fas fa-${toastVariant === 'success' ? 'check-circle' : 'exclamation-circle'} me-2`}></i>
                        {toastMessage}
                    </Toast.Body>
                </Toast>
            </div>

            <Tab.Container defaultActiveKey="list">
                <Nav variant="tabs" className="mb-4">
                    <Nav.Item>
                        <Nav.Link eventKey="list">Templates List</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="add">Add Template</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="test">Test Template</Nav.Link>
                    </Nav.Item>
                </Nav>

                <Tab.Content>
                    <Tab.Pane eventKey="list">
                        <TemplateList showNotification={showNotification} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="add">
                        <AddTemplate showNotification={showNotification} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="test">
                        <TestTemplate showNotification={showNotification} />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </Container>
    );
};

export default MessageTemplatesPage;